import { render } from "./ExchangeRateModalTable.vue?vue&type=template&id=165dc2a6&scoped=true"
import script from "./ExchangeRateModalTable.vue?vue&type=script&lang=js"
export * from "./ExchangeRateModalTable.vue?vue&type=script&lang=js"

import "./ExchangeRateModalTable.vue?vue&type=style&index=0&id=165dc2a6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165dc2a6"]])

export default __exports__